<div class="container">
    <div class="row">
        <div class="col-12">
        </div>
    </div>
    <app-adv-edit #advEditComponent _adView="1" [_adType]="2"></app-adv-edit>
</div>